/* eslint-disable */
import {last} from 'lodash';
import {ICalendarSelectorGroup, ICalendarSelectorItem} from '../types';

export function getGroups(items: ICalendarSelectorItem[] | null, groupSize: number, groupMask?: (val: string) => string) {
  if (items !== null) {
    const result: ICalendarSelectorGroup[] = [], payload = [...items].reverse();
    while (payload.length) {
      const groupItems = payload.splice(0, groupSize).reverse();
      const displayValues = groupItems.map(x => (groupMask ? groupMask(x.item.name) : x.item.name));
      const group = {
        displayValues,
        id: groupItems.map(x => x.item.id).join("#"),
        name: `${displayValues[0]} - ${last(displayValues)}`,
        items: groupItems,
        values: groupItems.map(x => x.item.id)
      };
      result.push(group);
    } 
    return result.reverse();
  }
  return [];
}